import { useState } from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  TextField,
  Typography
} from '@mui/material'
import css from './DatosAcceso.module.css'

const DatosAcceso = ({ accesoAlumno }) => {
  const [isExpanded, setExpanded] = useState(true)

  const handleChange = (_event, isExpanded) => setExpanded(isExpanded)

  return (
    <Accordion expanded={isExpanded} onChange={handleChange}>
      <AccordionSummary
        expandIcon={<i className='material-icons'>expand_more</i>}
      >
        <div className={css.label}>
          <Typography className={css.title} variant='h2'>
            Email de acceso a Classfy
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <div className={css.info}>
          {!accesoAlumno.activo && (
            <Alert
              icon={<i className='material-icons'>warning</i>}
              className={css.alert}
              severity='error'
            >
              Este acceso ha sido desactivado
            </Alert>
          )}
          <TextField
            label='Email'
            value={accesoAlumno.email}
            variant='standard'
          />
        </div>
      </AccordionDetails>
    </Accordion>
  )
}

export default DatosAcceso
